import axios from "../../../axios"
import { getCurrentTenant, encodeToBase64 } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          tenantInfos {
              id,
              logo,
              document,
              about_us,
              document_ae,
              company_name,
              document_afe,
              phone_number,
              address_state,
              working_hours,
              document_crft,
              corporate_name,
              address_street,
              address_city,
              address_number,
              address_zip_code,
              nickname_facebook,
              address_complement,
              nickname_instagram,
              address_neighbourhood,
              document_vigilance_sanitary,
          }
        }
    `
    })
  },


  createTenantInfo(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createTenantInfo(
              logo: "${data.logo}",
              about_us: "${encodeToBase64(data.about_us)}",
              document: "${data.document}",
              document_ae: "${data.document_ae}",
              company_name: "${data.company_name}",
              document_afe: "${data.document_afe}",
              phone_number: "${data.phone_number}",
              address_city: "${data.address_city}",
              address_state: "${data.address_state}",
              working_hours: "${data.working_hours}",
              document_crft: "${data.document_crft}",
              corporate_name: "${data.corporate_name}",
              address_street: "${data.address_street}",
              address_number: "${data.address_number}",
              address_zip_code: "${data.address_zip_code}",
              nickname_facebook: "${data.nickname_facebook}",
              nickname_instagram: "${data.nickname_instagram}",
              address_complement: "${data.address_complement}",
              address_neighbourhood: "${data.address_neighbourhood}",
              document_vigilance_sanitary: "${data.document_vigilance_sanitary}",
          ) {
              id,
              logo,
              about_us,
              document,
              document_ae,
              company_name,
              document_afe,
              phone_number,
              address_city,
              address_state,
              working_hours,
              document_crft,
              corporate_name,
              address_street,
              address_number,
              address_zip_code,
              nickname_facebook,
              nickname_instagram,
              address_complement,
              address_neighbourhood,
              document_vigilance_sanitary,
          }
        }
    `
    })
  },

  updateTentanceInfo(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
            updateTenantInfo(
              id: ${data.id}
              logo: "${data.logo}",
              about_us: "${encodeToBase64(data.about_us)}",
              document: "${data.document}",
              document_ae: "${data.document_ae}",
              company_name: "${data.company_name}",
              document_afe: "${data.document_afe}",
              phone_number: "${data.phone_number}",
              address_city: "${data.address_city}",
              address_state: "${data.address_state}",
              working_hours: "${data.working_hours}",
              document_crft: "${data.document_crft}",
              corporate_name: "${data.corporate_name}",
              address_street: "${data.address_street}",
              address_number: "${data.address_number}",
              address_zip_code: "${data.address_zip_code}",
              nickname_facebook: "${data.nickname_facebook}",
              address_complement: "${data.address_complement}",
              nickname_instagram: "${data.nickname_instagram}",
              address_neighbourhood: "${data.address_neighbourhood}",
              document_vigilance_sanitary: "${data.document_vigilance_sanitary}",
            ) {
                id,
                logo,
                document,
                about_us,
                document_ae,
                company_name,
                document_afe,
                phone_number,
                address_city,
                address_state,
                working_hours,
                document_crft,
                corporate_name,
                address_street,
                address_number,
                address_zip_code,
                nickname_facebook,
                nickname_instagram,
                address_complement,
                address_neighbourhood,
                document_vigilance_sanitary,
            }
        }
    
    `
    })
  },

  deleteTenanceInfo() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
            deleteTenantInfo(
                id : 1
            )
        }
      `
    })
  }
}
